import { render, staticRenderFns } from "./emailSidebar.vue?vue&type=template&id=081bb7e4"
import script from "./emailSidebar.vue?vue&type=script&lang=js"
export * from "./emailSidebar.vue?vue&type=script&lang=js"
import style0 from "./emailSidebar.vue?vue&type=style&index=0&id=081bb7e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports